import React, { Component } from 'react';
import { Menu, Tooltip } from "antd";
import CrcMonthInGroup from './crcMonthInGroup';
import ProMonthInGroupConsumeFte from './proMonthInGroupConsumeFte';
import CenterMonthInGroupConsumeFte from './centerMonthInGroupConsumeFte';
import VisitTypeConsumeFte from './visitTypeConsumeFte';
import CrcFirstlyWorkTime from './crcFirstlyWorkTime';
import CrcDistributionJoinPro from './crcDistributionJoinPro';
import PatientVisitHour from './patientVisitHour';
import RandomInGroupVisit from './randomInGroupVisit';
import ConsumeFteContributeFte from './consumeFteContributeFte';
import SiteStart from './siteStart';
import VisitNum from './visitNum';
import RevenueVisitAndContractPlan from '../revenueVisitAndContractPlan/index';
import ProjectVisitNum from './projectVisitNum';
import CenterPlanStartNum from './centerPlanStartNum';
import ProjectMonPlanStartNum from './projectMonPlanStartNum';
import VisitNumComparison from './visitNumComparison';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import AreaHospitalCRC from './areaHospitalCRC';
import PositionCrcSecondPoint from './positionCrcSecondPoint';
import CrcStandardAmount from './crcStandardAmount';
import HosAndDepChange from './hosAndDepChange';
import CrcOutput from './crcOutput';
import PracticalJoinNum from './practicalJoinNum';
import PracticalVisitNum from './practicalVisitNum';
import PracticalStandardVisitNum from './practicalStandardVisitNum';
import VisitInCashMakeReturn from './visitInCashMakeReturn';
import NewOutPut from './newOutPut';
import ReturnedMoney from '../returnedMoney/index';
import ProjectDataStatistics from './projectDataStatistics';


const SubMenu = Menu.SubMenu;

class index extends Component {
    state = {
        exportable: false,
        current: 'INV_MONTH_START_PLAN_COUNT',
        openKeys: ['PROJECT_DATA_QUERY'],
        isAdditionalUser: false,  //是否为后台配置的可以查看报表查询的人员
    }

    componentDidMount() {
        this.queryEffectiveDate();
        this.setAdditionalMenu();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const date = moment(res.date).date();
            this.setState({ exportable: date >= 1 && date <= 25 });
        });
    }

    setAdditionalMenu = () => {
        const { additionalMenuList = [] } = this.props;
        let isAdditionalUser = false; //是否为后台配置的可以查看报表查询的人员
        let current = '';
        let defaultOpenKey = '';
        additionalMenuList.map((el, index, arr) => {
            if (el.menuKey === 'REPORT_QUERY') {
                isAdditionalUser = true;
                defaultOpenKey = arr[index + 1].menuKey;
                current = arr[index + 2].menuKey;
            }
        })
        if (isAdditionalUser) {
            this.setState({ 
                isAdditionalUser,
                current,
            },() => {
                this.handleOpenChange([defaultOpenKey])
            });
        }
        
    }

    haveMenu = (value) => {
        const { isAdditionalUser } = this.state;
        const { additionalMenuList = [] } = this.props;
        if (isAdditionalUser) {
            return additionalMenuList.some(el => el.menuKey === value)
        } else {
            return true
        }
    }

    handleOpenChange = openKeys => {
        this.setState({ openKeys });
    }

    handleClick = e => {
        this.setState({ current: e.key });
    }

    render() {
        const { current, exportable, openKeys } = this.state;
        const { curRole } = sessionStorage;
        return (
            <div className="tabWidth">
                <div className="flexBox">
                    <aside className="sidebar" style={{ height: 'auto', background: '#E0E4F1' }}>
                        <Menu
                            onClick={this.handleClick}
                            openKeys={openKeys}
                            onOpenChange={this.handleOpenChange}
                            selectedKeys={[current]}
                            mode="inline"
                        >
                            {this.haveMenu('PROJECT_DATA_QUERY') &&
                                <SubMenu key="PROJECT_DATA_QUERY" title="项目数据查询">
                                    {
                                        this.haveMenu('INV_MONTH_START_PLAN_COUNT') && <Menu.Item key="INV_MONTH_START_PLAN_COUNT">
                                            <Tooltip placement="right" title='各项目各月启动计划数'>
                                                <a>各项目各月启动计划数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('INV_FILTER_RANDOM_VISIT_FTE') && <Menu.Item key="INV_FILTER_RANDOM_VISIT_FTE">
                                            <Tooltip placement="right" title='各项目每月筛选数、入组数、访视数、标准访视数、FTE情况'>
                                                <a>各项目每月筛选数、入组数、访视数、标准访视数、FTE情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('INV_CRC_PATIENT_WORK_VISIT') && <Menu.Item key="INV_CRC_PATIENT_WORK_VISIT">
                                            <Tooltip placement="right" title='各项目CRC“患者访视”工作类型的工时明细&访视类型明细情况'>
                                                <a>各项目CRC“患者访视”工作类型的工时明细&访视类型明细情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('INV_USER_MONTH_RANDOM_VISIT_WORK_TYPE') && <Menu.Item key="INV_USER_MONTH_RANDOM_VISIT_WORK_TYPE">
                                            <Tooltip placement="right" title='各项目各成员每月完成随机入组、访视&各工作类型工时明细情况'>
                                                <a>各项目各成员每月完成随机入组、访视&各工作类型工时明细情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('INV_MONTH_VISIT_RANDOM_REQUEST_INVOICE_BACK') && <Menu.Item key="INV_MONTH_VISIT_RANDOM_REQUEST_INVOICE_BACK">
                                            <Tooltip placement="right" title='各项目各月访视、入组、请款、开票、回款比例分析'>
                                                <a>各项目各月访视、入组、请款、开票、回款比例分析</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('INV_CUSTOMER_FTE') && <Menu.Item key="INV_CUSTOMER_FTE">
                                            <Tooltip placement="right" title='各项目各客户FTE数据统计'>
                                                <a>各项目各客户FTE数据统计</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                </SubMenu>
                            }

                            {
                                this.haveMenu('SITE_DATA_QUERY') && <SubMenu key="SITE_DATA_QUERY" title="中心数据查询">
                                    {
                                        this.haveMenu('SITE_HOSPITAL_DEPT_CRC_RANDOM') && <Menu.Item key="SITE_HOSPITAL_DEPT_CRC_RANDOM">
                                            <Tooltip placement="right" title='各医院科室每个CRC月入组情况'>
                                                <a>各医院科室每个CRC月入组情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_FILTER_RANDOM_VISIT_FTE') && <Menu.Item key="SITE_FILTER_RANDOM_VISIT_FTE">
                                            <Tooltip placement="right" title='各项目各中心每月筛选数、入组数、访视数、标准访视数、FTE情况'>
                                                <a>各项目各中心每月筛选数、入组数、访视数、标准访视数、FTE情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_MONTH_VISIT_TYPE_FTE_RANDOM') && <Menu.Item key="SITE_MONTH_VISIT_TYPE_FTE_RANDOM">
                                            <Tooltip placement="right" title='各项目各中心每月各访视类型&消耗FTE情况&患者随机月'>
                                                <a>各项目各中心每月各访视类型&消耗FTE情况&患者随机月</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }

                                    {
                                        this.haveMenu('SITE_AREA_CITY_HOSPITAL_CRC_DEPT') && <Menu.Item key="SITE_AREA_CITY_HOSPITAL_CRC_DEPT">
                                            <Tooltip placement="right" title='各区域各城市各医院上的CRC的科室分布、领域分布'>
                                                <a>各区域各城市各医院上的CRC的科室分布、领域分布</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }

                                    {
                                        this.haveMenu('SITE_CRC_MONTH_RANDOM_VSIT_FTE') && <Menu.Item key="SITE_CRC_MONTH_RANDOM_VSIT_FTE">
                                            <Tooltip placement="right" title='各项目各中心下，各CRC在各月完成的入组数量，访视数、标准访视数、产生的项目确认FTE'>
                                                <a>各项目各中心下，各CRC在各月完成的入组数量，访视数、标准访视数、产生的项目确认FTE</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_PLAN_VISIT_STANDARD_COUNT') && <Menu.Item key="SITE_PLAN_VISIT_STANDARD_COUNT">
                                            <Tooltip placement="right" title='各项目各中心计划访视数、计划标准访视数'>
                                                <a>各项目各中心计划访视数、计划标准访视数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_PLAN_RANDOM_VISIT_ACTUAL_COMPARE') && <Menu.Item key="SITE_PLAN_RANDOM_VISIT_ACTUAL_COMPARE">
                                            <Tooltip placement="right" title='各项目各中心计划入组数&访视数和实际对比'>
                                                <a>各项目各中心计划入组数&访视数和实际对比</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_MONTH_PLAN_ACTUAL_RANDOM') && <Menu.Item key="SITE_MONTH_PLAN_ACTUAL_RANDOM">
                                            <Tooltip placement="right" title='各项目各中心每月计划/实际入组数'>
                                                <a>各项目各中心每月计划/实际入组数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_MONTH_PLAN_ACTUAL_VISIT') && <Menu.Item key="SITE_MONTH_PLAN_ACTUAL_VISIT">
                                            <Tooltip placement="right" title='各项目各中心每月计划/实际访视数'>
                                                <a>各项目各中心每月计划/实际访视数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_MONTH_PLAN_ACTUAL_STANDARD_VISIT') && <Menu.Item key="SITE_MONTH_PLAN_ACTUAL_STANDARD_VISIT">
                                            <Tooltip placement="right" title='各项目各中心每月计划/实际标准访视数'>
                                                <a>各项目各中心每月计划/实际标准访视数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_PLAN_ACTUAL_START_NUM') && <Menu.Item key="SITE_PLAN_ACTUAL_START_NUM">
                                            <Tooltip placement="right" title='各项目各中心计划/实际启动数'>
                                                <a>各项目各中心计划/实际启动数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('SITE_START_RECORD') && <Menu.Item key="SITE_START_RECORD">
                                            <Tooltip placement="right" title='中心启动记录'>
                                                <a>中心启动记录</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                </SubMenu>
                            }

                            {
                                this.haveMenu('EMPLOYEE_DATA_QUERY') && <SubMenu key="EMPLOYEE_DATA_QUERY" title="人员数据查询">
                                    {
                                        this.haveMenu('CRC_FIRST_JOIN_INV_TIME') && <Menu.Item key="CRC_FIRST_JOIN_INV_TIME">
                                            <Tooltip placement="right" title='CRC首次在项目工作时间'>
                                                <a>CRC首次在项目工作时间</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('CITY_CRC_INV_AREA_HOSPITAL') && <Menu.Item key="CITY_CRC_INV_AREA_HOSPITAL">
                                            <Tooltip placement="right" title='各城市CRC分布及参与某领域项目的中心情况'>
                                                <a>各城市CRC分布及参与某领域项目的中心情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('LEADER_MEMBER_INV_FTE_ASSIGN_FTE') && <Menu.Item key="LEADER_MEMBER_INV_FTE_ASSIGN_FTE">
                                            <Tooltip placement="right" title='某人员主管下各组员在项目中消耗FTE&分配FTE情况'>
                                                <a>某人员主管下各组员在项目中消耗FTE&分配FTE情况</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }

                                    {
                                        this.haveMenu('CRC_YEAR_PERFORMANCE_HIGH_SCORE') && <Menu.Item key="CRC_YEAR_PERFORMANCE_HIGH_SCORE">
                                            <Tooltip placement="right" title='临床协调员II近一年CRC绩效得分最高的6个月统计'>
                                                <a>临床协调员II近一年CRC绩效得分最高的6个月统计</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }

                                    {
                                        this.haveMenu('CRC_MONTH_STANDARD_VISIT_AMOUNT') && <Menu.Item key="CRC_MONTH_STANDARD_VISIT_AMOUNT">
                                            <Tooltip placement="right" title='临床协调员I、II的各月标准访视数'>
                                                <a>临床协调员I、II的各月标准访视数</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('CRC_PERSONNEL_OUTPUT') && <Menu.Item key="CRC_PERSONNEL_OUTPUT">
                                            <Tooltip placement="right" title='CRC人员产出'>
                                                <a>CRC人员产出</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        this.haveMenu('NEW_CRC_PERSONNEL_OUTPUT') && <Menu.Item key="NEW_CRC_PERSONNEL_OUTPUT">
                                            <Tooltip placement="right" title='新人员产出率'>
                                                <a>新人员产出率</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                </SubMenu>
                            }

                            {
                                this.haveMenu('INCOME_DATA_QUERY') && <SubMenu key="INCOME_DATA_QUERY" title="收入数据查询">
                                    {
                                        this.haveMenu('INCOME_VISIT_CONTRACT_PLAN_VISIT') && <Menu.Item key="INCOME_VISIT_CONTRACT_PLAN_VISIT">
                                            <Tooltip placement="right" title='收入访视&合同计划访视报告'>
                                                <a>收入访视&合同计划访视报告</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                    {
                                        curRole == 'HRRC' &&
                                        <Menu.Item key="INCOME_DATA_BACK_REPORT">
                                            <Tooltip placement="right" title='发票和回款记录报告'>
                                                <a>发票和回款记录报告</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                </SubMenu>
                            }
                            {
                                this.haveMenu('HOSPITAL_DATA_QUERY') && <SubMenu key="HOSPITAL_DATA_QUERY" title="医院数据查询">
                                    {
                                        this.haveMenu('HOSPITAL_DEPT_CHANGE_RECORD') && <Menu.Item key="HOSPITAL_DEPT_CHANGE_RECORD">
                                            <Tooltip placement="right" title='医院&医院科室变更记录'>
                                                <a>医院&医院科室变更记录</a>
                                            </Tooltip>
                                        </Menu.Item>
                                    }
                                </SubMenu>
                            }
                        </Menu>
                    </aside>
                    
                    <div style={{minHeight: 500, width: '84%', marginLeft: '1%', padding: 20, background: 'white' }}>
                        { current === 'SITE_HOSPITAL_DEPT_CRC_RANDOM' && <CrcMonthInGroup title='各医院科室每个CRC月入组情况' exportable={true}/> }
                        { current === 'INV_FILTER_RANDOM_VISIT_FTE' && <ProMonthInGroupConsumeFte title='各项目每月筛选数、入组数、访视数、标准访视数、FTE情况' exportable={exportable}/> }
                        { current === 'SITE_FILTER_RANDOM_VISIT_FTE' && <CenterMonthInGroupConsumeFte title = '各项目各中心每月筛选数、入组数、访视数、标准访视数、FTE情况' exportable={exportable}/> }
                        { current === 'SITE_MONTH_VISIT_TYPE_FTE_RANDOM' && <VisitTypeConsumeFte title='各项目各中心每月各访视类型&消耗FTE情况&患者随机月' exportable={exportable}/> }
                        { current === 'INV_MONTH_START_PLAN_COUNT' && <ProjectMonPlanStartNum title='各项目各月启动计划数' exportable={exportable}/> }
                        { current === 'CRC_FIRST_JOIN_INV_TIME' && <CrcFirstlyWorkTime title='CRC首次在项目工作时间' exportable={exportable}/> }
                        { current === 'CITY_CRC_INV_AREA_HOSPITAL' && <CrcDistributionJoinPro title='各城市CRC分布及参与某领域项目的中心情况' exportable={true}/> }
                        { current === 'INV_CRC_PATIENT_WORK_VISIT' && <PatientVisitHour title='各项目CRC“患者访视”工作类型的工时明细&访视类型明细情况' exportable={exportable}/> }
                        { current === 'INV_USER_MONTH_RANDOM_VISIT_WORK_TYPE' && <RandomInGroupVisit title='各项目各成员每月完成随机入组、访视&各工作类型工时明细情况' exportable={exportable}/> }
                        { current === 'SITE_PLAN_VISIT_STANDARD_COUNT' && <ProjectVisitNum title='各项目各中心计划访视数、计划标准访视数' exportable={exportable}/> }
                        { current === 'SITE_PLAN_RANDOM_VISIT_ACTUAL_COMPARE' && <VisitNumComparison title='各项目各中心计划入组数&访视数和实际对比' exportable={exportable}/> }
                        { current === 'SITE_PLAN_ACTUAL_START_NUM' && <CenterPlanStartNum title='各项目各中心计划/实际启动数' exportable={exportable}/> }
                        { current === 'LEADER_MEMBER_INV_FTE_ASSIGN_FTE' && <ConsumeFteContributeFte title='某人员主管下各组员在项目中消耗FTE&分配FTE情况' exportable={exportable}/> }
                        { current === 'SITE_START_RECORD' && <SiteStart title='中心启动记录' exportable={true}/> }
                        { current === 'SITE_CRC_MONTH_RANDOM_VSIT_FTE' && <VisitNum title='各项目各中心下，各CRC在各月完成的入组数量，访视数、标准访视数、产生的项目确认FTE' exportable={true}/> }
                        { current === 'INCOME_VISIT_CONTRACT_PLAN_VISIT' && <RevenueVisitAndContractPlan title='收入访视&合同计划访视报告' exportable={true}/> }
                        { current === 'INCOME_DATA_BACK_REPORT' && <ReturnedMoney title='发票和回款记录报告' exportable={true}/> }
                        { current === 'SITE_AREA_CITY_HOSPITAL_CRC_DEPT' && <AreaHospitalCRC title='各区域各城市各医院上的CRC的科室分布、领域分布' exportable={true}/> }
                        { current === 'CRC_YEAR_PERFORMANCE_HIGH_SCORE' && <PositionCrcSecondPoint title='临床协调员II近一年CRC绩效得分最高的6个月统计' exportable={true}/> }
                        { current === 'CRC_MONTH_STANDARD_VISIT_AMOUNT' && <CrcStandardAmount title='临床协调员I、II的各月标准访视数' exportable={true}/> }
                        { current === 'CRC_PERSONNEL_OUTPUT' && <CrcOutput title='CRC人员产出' exportable={true}/> }
                        { current === 'NEW_CRC_PERSONNEL_OUTPUT' && <NewOutPut title='新人员产出率' exportable={true}/> }
                        { current === 'HOSPITAL_DEPT_CHANGE_RECORD' && <HosAndDepChange title='医院&医院科室变更记录' exportable={true}/> }
                        { current === 'SITE_MONTH_PLAN_ACTUAL_RANDOM' && <PracticalJoinNum title='各项目各中心每月计划/实际入组数' exportable={true}/> }
                        { current === 'SITE_MONTH_PLAN_ACTUAL_VISIT' && <PracticalVisitNum title='各项目各中心每月计划/实际访视数' exportable={true}/> }
                        { current === 'SITE_MONTH_PLAN_ACTUAL_STANDARD_VISIT' && <PracticalStandardVisitNum title='各项目各中心每月计划/实际标准访视数' exportable={true}/> }
                        { current === 'INV_MONTH_VISIT_RANDOM_REQUEST_INVOICE_BACK' && <VisitInCashMakeReturn title='各项目各月访视、入组、请款、开票、回款比例分析' exportable={true}/> }
                        { current === 'INV_CUSTOMER_FTE' && <ProjectDataStatistics title='各项目各客户FTE数据统计' exportable={true}/> }
                    </div>
                        {/* <div style={{minHeight: 500, width: '84%', marginLeft: '1%', padding: 20, background: 'white' }}>
                        { current === 'crcMonthInGroup' && <CrcMonthInGroup title='各医院科室每个CRC月入组情况' exportable={true}/> }
                        { current === 'proMonthInGroupConsumeFte' && <ProMonthInGroupConsumeFte title='各项目每月筛选数、入组数、访视数、标准访视数、FTE情况' exportable={exportable}/> }
                        { current === 'centerMonthInGroupConsumeFte' && <CenterMonthInGroupConsumeFte title = '各项目各中心每月筛选数、入组数、访视数、标准访视数、FTE情况' exportable={exportable}/> }
                        { current === 'visitTypeConsumeFte' && <VisitTypeConsumeFte title='各项目各中心每月各访视类型&消耗FTE情况&患者随机月' exportable={exportable}/> }
                        { current === 'ProjectMonPlanStartNum' && <ProjectMonPlanStartNum title='各项目各月启动计划数' exportable={exportable}/> }
                        { current === 'crcFirstlyWorkTime' && <CrcFirstlyWorkTime title='CRC首次在项目工作时间' exportable={exportable}/> }
                        { current === 'crcDistributionJoinPro' && <CrcDistributionJoinPro title='各城市CRC分布及参与某领域项目的中心情况' exportable={true}/> }
                        { current === 'patientVisitHour' && <PatientVisitHour title='各项目CRC“患者访视”工作类型的工时明细&访视类型明细情况' exportable={exportable}/> }
                        { current === 'randomInGroupVisit' && <RandomInGroupVisit title='各项目各成员每月完成随机入组、访视&各工作类型工时明细情况' exportable={exportable}/> }
                        { current === 'ProjectVisitNum' && <ProjectVisitNum title='各项目各中心计划访视数、计划标准访视数' exportable={exportable}/> }
                        { current === 'VisitNumComparison' && <VisitNumComparison title='各项目各中心计划入组数&访视数和实际对比' exportable={exportable}/> }
                        { current === 'CenterPlanStartNum' && <CenterPlanStartNum title='各项目各中心计划/实际启动数' exportable={exportable}/> }
                        { current === 'consumeFteContributeFte' && <ConsumeFteContributeFte title='某人员主管下各组员在项目中消耗FTE&分配FTE情况' exportable={exportable}/> }
                        { current === 'siteStart' && <SiteStart title='中心启动记录' exportable={true}/> }
                        { current === 'visitNum' && <VisitNum title='各项目各中心下，各CRC在各月完成的入组数量，访视数、标准访视数、产生的项目确认FTE' exportable={true}/> }
                        { current === 'revenueVisitAndContractPlan' && <RevenueVisitAndContractPlan title='收入访视&合同计划访视报告' exportable={true}/> }
                        { current === 'returnedMoney' && <ReturnedMoney title='发票和回款记录报告' exportable={true}/> }
                        { current === 'areaHospitalCRC' && <AreaHospitalCRC title='各区域各城市各医院上的CRC的科室分布、领域分布' exportable={true}/> }
                        { current === 'positionCrcSecondPoint' && <PositionCrcSecondPoint title='临床协调员II近一年CRC绩效得分最高的6个月统计' exportable={true}/> }
                        { current === 'crcStandardAmount' && <CrcStandardAmount title='临床协调员I、II的各月标准访视数' exportable={true}/> }
                        { current === 'crcOutput' && <CrcOutput title='CRC人员产出' exportable={true}/> }
                        { current === 'newOutput' && <NewOutPut title='新人员产出率' exportable={true}/> }
                        { current === 'hospitalAndDepartmentChange' && <HosAndDepChange title='医院&医院科室变更记录' exportable={true}/> }
                        { current === 'practicalJoinNum' && <PracticalJoinNum title='各项目各中心每月计划/实际入组数' exportable={true}/> }
                        { current === 'practicalVisitNum' && <PracticalVisitNum title='各项目各中心每月计划/实际访视数' exportable={true}/> }
                        { current === 'practicalStandardVisitNum' && <PracticalStandardVisitNum title='各项目各中心每月计划/实际标准访视数' exportable={true}/> }
                        { current === 'VisitInCashMakeReturn' && <VisitInCashMakeReturn title='各项目各月访视、入组、请款、开票、回款比例分析' exportable={true}/> }
                        { current === 'ProjectDataStatistics' && <ProjectDataStatistics title='各项目各客户FTE数据统计' exportable={true}/> }
                    </div> */}
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/index.js